import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    systemcode: [],
    category: [],
    localinfo: [],
    localinfotype: []
  },
  mutations: {
  },
  actions: {
    async getSystemCategory ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_SYSTEM_PARAMS,
          id: store.state.authentication.requestId
        })
        const expressCheckin = {
          desc: 'Express Checkin',
          name: 'system_express_checkin',
          order: 99
        }
        const array = (res.data && res.data.message) || []
        state.systemcode = array.concat(expressCheckin)
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async getCategory ({ state, dispatch }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_SERVICE_PARAMS,
          id: store.state.authentication.requestId
        })
        state.category = res.data.message
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async getCategoryCode ({ state, dispatch }) {
      const res = await Promise.all([
        dispatch('getSystemCategory'),
        dispatch('getCategory')
      ])
      return res
    },
    async setCategory ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_SERVICE_PARAMS,
          id: store.state.authentication.requestId,
          data: data
        })
        return res
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async getLocalList ({ state }) {
      const site = store.state.authentication.userInfo.siteid
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-local-info&siteid=${site}&type=all`)
        state.localinfo = res.data.message
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return ex.response.data
      }
    },
    async getLocalInfoType ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_LOCAL_INFO_CATEGORY,
          id: store.state.authentication.requestId
        })
        state.localinfotype = res.data.message
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    }
  },
  getters: {
    systemcategory (state) {
      return state.systemcode
    },
    category (state) {
      return state.category
    },
    localinfo (state) {
      return state.localinfo
    },
    localinfotype (state) {
      const realtype = state.localinfo.map(x => x.siteType)
      return state.localinfotype.filter(x => realtype.includes(x))
    }
  }
}
